import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { isString, __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import Icon from '../Icon/index.esm.js';

var Link = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      as = _props$as === void 0 ? 'a' : _props$as,
      children = props.children,
      disabled = props.disabled,
      external = props.external,
      externalIcon = props.externalIcon,
      onClick = props.onClick,
      target = props.target,
      rest = _objectWithoutPropertiesLoose(props, ["as", "children", "disabled", "external", "externalIcon", "onClick", "target"]);

  var externalProps = external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : null;
  var displayIcon = typeof externalIcon === 'boolean' ? externalIcon : external || isString(target) && target === '_blank';
  var styleProps = {
    textColor: ['text-blue-500', 'hover:text-blue-700', 'focus:text-blue-700'],
    textDecoration: ['hover:underline', 'focus:underline'],
    boxShadow: ['focus:shadow-outline', 'focus:shadow-outline-blue'],
    transitionProperty: 'transition-all',
    transitionDuration: 'duration-200',
    outline: 'outline-none'
  };
  return React__default.createElement(Box, _extends({
    as: as,
    ref: ref,
    target: target,
    tabIndex: disabled ? -1 : undefined,
    "aria-disabled": disabled,
    onClick: disabled ? function (e) {
      return e.preventDefault();
    } : onClick
  }, externalProps, styleProps, rest), children, displayIcon && React__default.createElement(Icon, {
    name: "small-launch-app",
    display: "inline",
    verticalAlign: "align-middle",
    margin: "ml-1"
  }));
});

if (__DEV__) {
  Link.displayName = 'Link';
}

export default Link;
//# sourceMappingURL=index.esm.js.map
